import React from 'react';

import { OptionsContainer, OptionsDisplay } from './styles';

export const paymentTabs = {
  recurring: 'recurring',
  purchase: 'purchase',
};

export default function OptionsTab({ handleTabs, options, activeTab }) {
  const changeTabs = (tab) => {
    handleTabs(tab);
  };

  return (
    <OptionsContainer>
      {options.map((option) => (
        <OptionsDisplay key={option} activeTab={activeTab} option={option} onClick={() => changeTabs(option)}>
          {option === paymentTabs.purchase ? 'Purchase Tests' : 'Recurring'}
        </OptionsDisplay>
      ))}
    </OptionsContainer>
  );
}
